import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { CompanyChip, Coverage, MethodChip, StatusPill } from "../../design/components";
import { HEALTH_PILL, METHOD_BY_CONNECTION, STATUS_LABEL } from "../../domain/health";
import { relative } from "../../lib/format";
import type { EntitySummary } from "../../api/types";

/** Cell indices the tests assert on; failing and stopped_reporting are never merged. */
export const FAILING_COL = 4;
export const SILENT_COL = 5;

export function HealthTable({ entities }: { entities: EntitySummary[] }) {
  const { t } = useTranslation();
  return (
    <div className="table-wrap">
      <table className="tbl">
        <thead>
          <tr>
            <th>{t("dashboard.healthTable.columns.company", "Company")}</th>
            <th className="nowrap">{t("dashboard.healthTable.columns.method", "Method")}</th>
            <th>{t("dashboard.healthTable.columns.status", "Status")}</th>
            <th>{t("dashboard.healthTable.columns.health", "Health")}</th>
            <th className="c">{t("dashboard.healthTable.columns.failing", "Failing")}</th>
            <th className="c nowrap">{t("dashboard.healthTable.columns.noDocuments", "No documents")}</th>
            <th className="nowrap">{t("dashboard.healthTable.columns.lastDocument", "Last document")}</th>
            <th className="nowrap">
              {t("dashboard.healthTable.columns.mappingCoverage", "Mapping coverage")}
            </th>
          </tr>
        </thead>
        <tbody>
          {entities.map((entity) => (
            <tr key={entity.id}>
              <td>
                <Link className="link" to={`/companies/${entity.id}`}>
                  <CompanyChip entityId={entity.id} name={entity.legalName} code={entity.code} />
                </Link>
              </td>
              <td className="nowrap">
                <MethodChip method={METHOD_BY_CONNECTION[entity.connectionMethod]} />
              </td>
              <td>
                <StatusPill status={entity.status} label={STATUS_LABEL[entity.status]} />
              </td>
              <td className="nowrap">
                <StatusPill {...HEALTH_PILL[entity.health]} />
                {entity.healthChangedAt ? (
                  <span className="sub" data-testid="health-since">
                    {" "}
                    {t("dashboard.healthTable.since", "since")} {relative(entity.healthChangedAt)}
                  </span>
                ) : null}
              </td>
              <td className="c">{entity.health === "failing" ? "✓" : ""}</td>
              <td className="c">{entity.health === "stopped_reporting" ? "✓" : ""}</td>
              <td className="nowrap">
                {entity.lastDocumentSeenAt ? relative(entity.lastDocumentSeenAt) : "—"}
              </td>
              <td>
                <Coverage mappingCoverage={entity.mappingCoverage} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
